import { render, staticRenderFns } from "./AccessLocationView.vue?vue&type=template&id=634124bd"
import script from "./AccessLocationView.vue?vue&type=script&lang=js"
export * from "./AccessLocationView.vue?vue&type=script&lang=js"
import style0 from "./AccessLocationView.vue?vue&type=style&index=0&id=634124bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports